<template>
  <div style="padding: 5px;">
    <TableEmployee />
  </div>
</template>
<script>
import TableEmployee from "./components/tableEmployee";
export default {
  components: {
    TableEmployee,
  },
  data() {
    return {};
  },
  methods: {},
  created() {},
};
</script>
<style></style>
